export default __webpack_public_path__ + "static/RaiaDrogasil-d186e2ae22b0c17ae7d0f9c1563ec552.png";